import React from "react";
import Icon from "./Icon";

// Icons/Core/arrow-drop-down-line
function ArrowDown(props) {
  const svgPointsParameter = "12 15 7.757 10.757 9.172 9.343 12 12.172 14.828 9.343 16.243 10.757";
  return (<Icon {...props} svgPointsParameter={svgPointsParameter} />);
}

export default ArrowDown;
